// import Vue from 'vue'
import * as Sentry from '@sentry/browser'
type level = 'fatal' | 'error' | 'warning' | 'log' | 'info' | 'debug' | 'critical'

declare module 'vue/types/vue' {
  // use by inside Vue components
  interface Vue {
    $captureException(err: Error): void
    $captureMessage(message: string): void
  }
}

declare module '@nuxt/types/index' {
  // use by inside asyncData, fetch, plugins, middleware, nuxtServerInit
  interface NuxtAppOptions {
    $captureException(err: Error): void
    $captureMessage(msg: string): void
  }
  // use by nuxtContext
  interface Context {
    $captureException(err: Error): void
    $captureMessage(msg: string): void
  }
}

declare module 'vuex/types/index' {
  // use by inside Vuex stores
  // eslint-disable-next-line
  interface Store<S> {
    $captureException(err: Error): void
    $captureMessage(msg: string): void
  }
}

// TODO: nuxt2.9以降から@nuxt/typesの参照でcontextとinjectのanyを解消できる
// eslint-disable-next-line
export default (context: any, inject: any) => {
  inject('captureException', (err: Error) => Sentry.captureException(err))
  inject('captureMessage', (msg: string) => Sentry.captureMessage(msg))
}

// use by other
export class ErrorLog {
  static captureException(err: Error) {
    Sentry.captureException(err)
  }

  static captureMessage(message: string, level: level = 'error') {
    switch (level) {
      case 'fatal':
        Sentry.captureMessage(message, Sentry.Severity.Fatal)
        break
      case 'error':
        Sentry.captureMessage(message, Sentry.Severity.Error)
        break
      case 'warning':
        Sentry.captureMessage(message, Sentry.Severity.Warning)
        break
      case 'log':
        Sentry.captureMessage(message, Sentry.Severity.Log)
        break
      case 'info':
        Sentry.captureMessage(message, Sentry.Severity.Info)
        break
      case 'debug':
        Sentry.captureMessage(message, Sentry.Severity.Debug)
        break
      case 'critical':
        Sentry.captureMessage(message, Sentry.Severity.Critical)
        break
      default:
        break
    }
  }
}
